import type { ApiRoute, NoBody } from "../api"
import type { CustomerContactDetailsView } from "../common/customer/CustomerContactDetailsView"

export interface GetCustomerContactDetailsPathParams {
	businessPartnerId: string
}

export interface GetCustomerContactDetailsQueryParams {
	capSamlToken: string
}

export const getCustomerContactDetailsRoute: ApiRoute<
	GetCustomerContactDetailsPathParams,
	GetCustomerContactDetailsQueryParams,
	NoBody,
	CustomerContactDetailsView
> = {
	buildUrl: (params) => `/customer/${params.businessPartnerId}/contactDetails`,
	method: "get",
	path: "/customer/:businessPartnerId/contactDetails",
}
